import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import IGetVendorsDTO from "../../../models/DTO/IGetVendorsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import IOnProcessProjectDTO from "../../../models/DTO/IOnProcessProjectDTO";
import IProcessProjectDTO from "../../../models/DTO/IProcessProjectDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAddress from "../../../models/IAddress";
import INewAddress from "../../../models/INewAddress";
import IProject from "../../../models/IProject";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refresh?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    project?: IProject;
};

type State = {
    project: IProject;
    vendors: IVendorModel[];
    selectedVendor?: IVendorModel | null;
    clearVendorTypeahead: boolean;
};

class ProjectSidebar extends Component<Props, State> {
    readonly state: State = {
        project: this.props.project || ({} as IProject),
        vendors: [],
        clearVendorTypeahead: false,
        selectedVendor: this.props.project ? this.props.project.Vendor! : null,
    };

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.on(EndpointsEnum.ProjectsOnProcessProject, this.onProcessProject);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.removeListener(EndpointsEnum.ProjectsOnProcessProject, this.onProcessProject);
    }

    cancel = () => {
        this.props.cancelFn(false);
    };

    selectedVendor = (vendor: IVendorModel) => {
        const project = this.state.project;

        project.vendor_id = vendor.id;

        this.setState({
            project,
            selectedVendor: vendor,
        });
    };

    findVendorsByName = (typeahead: string) => {
        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = _.map(data.supplierVendorTokens, (tokenData) => {
            return tokenData.Vendor!;
        });

        this.setState({
            vendors: foundVendors,
        });
    };

    clearTypeaheadCallback = () => {
        const project = this.state.project;

        // @ts-expect-error
        project.vendor_id = null;

        this.setState({
            project,
            selectedVendor: null,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const project = this.state.project;

        // @ts-expect-error
        project[name] = value;

        this.setState({ project });
    };

    handleAddressChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const project = this.state.project;

        const address = project.Address || ({} as IAddress);

        // @ts-expect-error
        address[name] = value;

        project.Address = address;

        this.setState({ project });
    };

    saveProject = () => {
        if (this.state.project.name) {
            const payload: IProcessProjectDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                project: this.state.project,
            };

            this.props.socket.emit(EndpointsEnum.ProjectsProcessProject, payload);
        }
    };

    onProcessProject = (data: IOnProcessProjectDTO) => {
        this.props.cancelFn(true);
    };

    render() {
        return (
            <div className="ProjectSidebar p-2">
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className="text-end">
                            <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                                <i className="far fa-times" />
                            </button>
                        </div>
                        <OwTitle className={"mb-2"} leftIconName={"fad fa-project-diagram"} title={"project"} />
                        <hr />
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12"}>
                        <OwLabel title={"name"} showIsReqAsterik={true} noBottomMargin={true} />
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.project.name} />
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12"}>
                        <OwLabel
                            title={"vendor"}
                            supplierModel={this.props.supplierModel}
                            isSupplierVendorOverride={true}
                            noBottomMargin={true}
                        />
                        <div>
                            <div className="position-relative">
                                <div>
                                    <Typeahead
                                        className=""
                                        clearTypeahead={this.state.clearVendorTypeahead}
                                        clearTypeaheadCallback={() => {
                                            this.clearTypeaheadCallback();
                                        }}
                                        typeaheadItems={this.state.vendors}
                                        titleProp="name"
                                        subTitleProp=""
                                        maxResults={5}
                                        isRequired={true}
                                        placeholder="Search"
                                        selectedItem={this.state.selectedVendor}
                                        isSelectableFn={() => {
                                            return true;
                                        }}
                                        selectedItemFn={this.selectedVendor}
                                        typeaheadApiFn={this.findVendorsByName}
                                    />
                                </div>
                            </div>
                            {/*<OwSelectOption*/}
                            {/*    titleProp={"name"}*/}
                            {/*    titlePropTwo={"company_name"}*/}
                            {/*    valueProp={"id"}*/}
                            {/*    name={"vendor_id"}*/}
                            {/*    fn={this.handleChange}*/}
                            {/*    options={this.state.vendorOptions}*/}
                            {/*    selectedOption={this.state.project}*/}
                            {/*    selectedOptionProp={"vendor_id"}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12"}>
                        <OwLabel title={"address"} showIsReqAsterik={true} noBottomMargin={true} />
                        <div>
                            <AddressBlock address={this.state.project.Address} fn={this.handleAddressChange} />
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwButton title={"save"} fn={this.saveProject} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectSidebar;
